import { useQuery } from "react-query";
import { QUERY_KEY_HISTORY_CHATBOT } from "./keys";
import { api_chatbot } from "./api";
import { useAuthDetailStore, useAuthStore } from "../../stores/useAuthStore";

const useQueryChatbotHistory = () => {
    const infos = useAuthStore((state) => state.infos);
    const detail = useAuthDetailStore((state) => state.detail);

    const { data: histories, isLoading: isLoadingHistories } = useQuery(
        [QUERY_KEY_HISTORY_CHATBOT],
        api_chatbot.histories,
        {
            refetchOnWindowFocus: false,
            enabled:
                !!infos && !!detail && detail?.company?.has_chatbot_enabled,
        }
    );

    return {
        histories,
        isLoadingHistories,
    };
};

export default useQueryChatbotHistory;
